class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = this.querySelectorAll('[data-slide]');
    if (this.slides.length < 2) return;

    this.current = 0;
    const speed = (this.dataset.rotateSpeed || 5) * 1000;

    this.startAutoplay(speed);
    this.initSwipe();
    this.initButtons();
  }

  startAutoplay(speed) {
    this.interval = setInterval(() => this.next(), speed);
  }

  resetAutoplay() {
    clearInterval(this.interval);
    const speed = (this.dataset.rotateSpeed || 5) * 1000;
    this.startAutoplay(speed);
  }

  show(index) {
    this.slides[this.current].classList.replace('opacity-100', 'opacity-0');
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.replace('opacity-0', 'opacity-100');
  }

  next() {
    this.show(this.current + 1);
  }

  prev() {
    this.show(this.current - 1);
  }

  initButtons() {
    this.querySelector('[data-prev]')?.addEventListener('click', () => {
      this.prev();
      this.resetAutoplay();
    });
    this.querySelector('[data-next]')?.addEventListener('click', () => {
      this.next();
      this.resetAutoplay();
    });
  }

  initSwipe() {
    let startX = 0;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 30) return;

      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
      this.resetAutoplay();
    }, { passive: true });
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
